import { render, staticRenderFns } from "./pdfUpload.vue.js?vue&type=template&id=6b021cec&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./pdfUpload.vue?vue&type=template&id=6b021cec&scoped=true"
import script from "./pdfUpload.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./pdfUpload.vue?vue&type=script&lang=js"
export * from "./pdfUpload.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./pdfUpload.vue?vue&type=script&lang=js"
import style0 from "./pdfUpload.vue.scss?vue&type=style&index=0&id=6b021cec&lang=scss&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./pdfUpload.vue?vue&type=style&index=0&id=6b021cec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b021cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b021cec')) {
      api.createRecord('6b021cec', component.options)
    } else {
      api.reload('6b021cec', component.options)
    }
    module.hot.accept("./pdfUpload.vue.js?vue&type=template&id=6b021cec&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./pdfUpload.vue?vue&type=template&id=6b021cec&scoped=true", function () {
      api.rerender('6b021cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modal/course/components/pdfUpload.vue"
export default component.exports